import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { logoutUser } from "./../../redux/Actions/authActions";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiBackdrop-root": {
    backdropFilter: "blur(8px) brightness(0.5)",
    backgroundColor: "rgba(0,0,0,0.7)",
  },
}));

const SessionExpirationModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const goToLogin = () => {
    dispatch({ type: "CLEAR_SESSION_EXPIRED" });
    dispatch(logoutUser(false));
  };

  return (
    <StyledDialog
      open={true}
      aria-labelledby="session-expired-title"
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogTitle id="session-expired-title">
        {t("sessionExpiredTitle")}
      </DialogTitle>
      <DialogContent>{t("sessionExpiredMessage")}</DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={goToLogin}>
          {t("loginAgain")}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default SessionExpirationModal;
